module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAFGq+z1AAAAAXNSR0IArs4c6QAAAJpJREFUGBlVTrERwyAQ4/EdZWbwBh4gQwC1s0ucXZIaaNggA3gDz8El4BcHyfGN9EgvQd77ZyllFc65IjCdUCeC9Yl9b2ryh3ECJ6IrsE4IYe38f9te2PmSg12IrzHmVnWEow1FPaLikBljvKSUdnbNg6stHH8opZb6Tbzx9T3nvDW9gpRy01o/sPyMWLh/5oQdnBsWa+0BjjkB219Ggdg36mUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/header/img/meMoreIco.png
// module id = tnP5
// module chunks = 23